<template>
	<div class="container" :class="{'opac': isOpac}" style="-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;cursor:pointer;">		
			<!--底层，绘制白画布、时间轴和刻度-->
		<canvas id="canvas1" width=800 height=60 >Your browser does not support the canvas element.</canvas>	
			<!--中间层，根据后台数据添加象征分段信息的长方形-->
		<canvas id="canvas3" width=800 height=60>Your browser does not support the canvas element.</canvas>	
			<!--最上层，绘制滚动小球和代表小球轨迹的长方形-->
		<canvas id="canvas2" width=800 height=60 @mousedown="handleMouseDown">Your browser does not support the canvas element.</canvas>	
	</div>	
</template>
<script>
import {mapState} from 'vuex'
import {mapGetters} from 'vuex' 
export default {
  name: 'VehicleAxis',
  data () {
    return {
    	canvas1:{},			//绘制白画布、时间轴和刻度
    	canvas2:{},			//绘制滚动小球和代表小球轨迹的长方形
    	canvas3:{},			//根据后台数据添加象征分段信息的长方形
    	ctx1:'',
    	ctx2:'',
    	ctx3:'',
    	canvasW:'',
    	canvasH:'',
    	startX:'',
    	endX:'',
    	isDragging:false,
    	ballX:'',
    	firstX:'',
    	snippets:'',
    	unitX:'',
    	timer:'',
    	railInfo2:[],
    	showCanvas:false,
    	isPlaying:true
    }
  },
  	computed:{
  		...mapState({
			trackInfoList:state => state.vehicle.trackInfoList,
			xVal:state=>state.vehicle.xVal,
			trackId:state=>state.vehicle.trackId,
			isOpac:state => state.vehicle.isPlaying
		}),
		...mapGetters([
			'travels'
		])
  	},
  	watch: {
  		trackId:function(val){
  			this.drawRail()
  		},
  		xVal:function(val){//时间轴移动时改变的x轴值
  			if(val !== undefined){
  				this.draw(val)
  			}
  		},
	  	ballX:function(val){//小球位置（X值）
	  		this.$store.dispatch('getXval',val);
	  		const disX = val - this.snippets;//小球移动的距离
	  		//小球移动到该位置用了几个30s-
	  		const disT = disX / parseFloat(this.snippets / 120) 
	  		//小球移动到的位置所对应的小时
	  		const sec = parseFloat(disT / 120).toFixed(2);
	  		const totalSec = Number(sec);
	  		//播放时间轴时每一帧对应的轨迹信息
	  		const pos = this.findPosition(totalSec);
	  		this.$store.dispatch('getMomentTrack',pos);
	  	}
  },
  mounted(){
  		this.setCanvas() 
  		const that = this;
	    window.onresize = function temp() {
	    	that.setCanvas()
	    }; 
  		
  },
  
  methods:{
  	setCanvas(){
  		let canvas1 = this.init('canvas1');
  		let canvas2 = this.init('canvas2');
  		let canvas3 = this.init('canvas3');
  		this.$set(this,'canvas1',canvas1);
  		this.$set(this,'canvas2',canvas2);
  		this.$set(this,'canvas3',canvas3); 
  		const context1 = canvas1.getContext('2d');
  		if(context1){
  			this.$set(this,'ctx1',context1);
  			this.drawBg();
  		}
  		const context2 = canvas2.getContext('2d');
  		if(context2){
  			this.$set(this,'ctx2',context2);
  			let traceStart = timeToSec(this.trackInfoList[0].gpsTime) / 30 * this.unitX + this.snippets;
  			this.draw(traceStart);
  			this.$store.dispatch('saveStartX',traceStart);
  		}
  		const context3 = canvas3.getContext('2d');
  		if(context3){
  			this.$set(this,'ctx3',context3);	
  			this.drawRail()
  		} 	
  	},
  	init(id){//初始化画布
  		const canvas = document.getElementById(id);
  		if(canvas === null) return false;
  		canvas.width =  document.body.clientWidth * 0.8 - 220;
  		return canvas;
  	},
  	drawRail(){//画小球轨迹
  		for (let k = 0, length3 = this.travels.length; k < length3; k++) {         
            let pois = this.travels[k];
            this.ctx3.beginPath();
            this.ctx3.fillStyle="#A0EDAA";
            let startPoi = pois[0];
            let endPoi = pois[pois.length - 1]; 
            const stime1 = startPoi.gpsTime
            const etime1 = endPoi.gpsTime
            const stime2 = timeToSec(stime1) / 3600
            const etime2 = timeToSec(etime1) / 3600
            var startPixel = this.snippets * (parseFloat(stime2) + 1);
            var endPixel = this.snippets * (parseFloat(etime2) + 1);
            this.ctx3.fillRect(startPixel, 25, endPixel - startPixel, 10);
            this.ctx3.closePath();     
        }  
  	},
  	findPosition(curTime){
  			const pots = this.trackInfoList;
	  		let index = 0;
	  		if (pots && pots.length > 1) {	  		 
	  			const timeS = pots[0].gpsTime
	  			const timeS2 = timeToSec(timeS) / 3600 
	  			const timeE = pots[pots.length - 1].gpsTime
	  			const timeE2 = timeToSec(timeE) / 3600 	  			
	            if (curTime < timeS2) {
	                index = 0;
	                return pots[0];
	            }
	            if (curTime >  timeE2) { 	
	                index = pots.length - 1;	                
	                return pots[pots.length - 1]
	            } 
	            var index0 = binarySearch(pots, curTime);
	            index = index0;	    	          
	            if (index > 0 && index < pots.length - 2) {
	            	const targetT = pots[index].gpsTime
	            	const targetTi = parseFloat(timeToSec(targetT) / 3600).toFixed(2)
	           		const targetTime = Number(targetTi);
	           		if (curTime === targetTime) {
                		this.$store.dispatch('hasTrackX',this.xVal)
                	}
                	return pots[index];
	            } else {
	               return pots[index];
	            }
	        }	
  	},
  	drawBg(){
  		this.canvasW = this.canvas1.width;
  		this.canvasH = this.canvas1.height;
  		this.snippets = parseInt(this.canvasW / 26);//将画布分为26份，每份的宽度
  		this.unitX = parseFloat(this.snippets / 120);//每30秒钟的宽度
  		this.startX = this.snippets;//时间轴开始的X坐标，距离画布最左边的距离
  		this.endX = this.snippets * 25;//时间轴结束的X坐标，距离画布最右边的距离
		this.ctx1.clearRect(0,0,this.canvasW,this.canvasH);
//		this.$store.dispatch('saveStartX',this.startX);
		this.$store.dispatch('saveUnitX',this.unitX);
		this.$store.dispatch('saveEndX',this.endX);
  		//画白画布
  		this.ctx1.beginPath();
  		this.ctx1.fillStyle = "#fff";
  		this.ctx1.fillRect(0,0,this.canvasW,this.canvasH);
  		this.ctx1.closePath();

  		//画时间轴
  		this.ctx1.beginPath()
  		this.ctx1.moveTo(this.startX,35);
  		this.ctx1.quadraticCurveTo(this.startX - 5,28,this.startX,25);
  		this.ctx1.lineTo(this.endX,25);
  		this.ctx1.quadraticCurveTo(this.endX + 5,28,this.endX,35);
  		this.ctx1.lineTo(this.startX,35);
  		this.ctx1.fillStyle = "#E9E9E9";
		this.ctx1.closePath();
		this.ctx1.fill();
		//画1小时时间
		this.ctx1.save();
        this.ctx1.translate(0.5,0.5);
        //画文字
        for(let i = 0; i <= 24; i++){
            let txt = i;   
            this.ctx1.font = "bold 16px serif";
            this.ctx1.fillStyle = '#8E98A2'
            this.ctx1.fillText(txt,i*this.snippets + this.startX - 2,50)
        };
        //画半小时刻度线
        for(let i = 0; i <= 48; i++){
        	this.ctx1.beginPath();
        	this.ctx1.moveTo(i*this.snippets / 2 + this.startX,34);
            this.ctx1.lineTo(i*this.snippets / 2 + this.startX,25);
            this.ctx1.strokeStyle = '#d1d1d1';
            this.ctx1.closePath();
            this.ctx1.stroke();
        }
  	},
  	draw(x){
  		const d = 20;//小球直径
  		this.ctx2.clearRect(0,0,this.canvasW,this.canvasH)
        //画可拖动球 以及 球滚动轨迹
        this.ballX = x || this.startX;
        if(x < this.snippets) this.ballX = this.snippets;
        if(x > this.endX) this.ballX = this.endX;
  		//画可拖动球
        this.ctx2.beginPath();
  		this.ctx2.fillStyle = "#46AC89";
  		this.ctx2.arc(this.ballX,30,d/2,0,Math.PI * 2,false);
  		this.ctx2.closePath();
  		this.ctx2.fill();	
  		//画球滚动后的轨迹
       /* this.ctx2.beginPath();
  		this.ctx2.fillStyle = "rgba(32,178,170,0.3)";
  		this.ctx2.fillRect(this.startX,25,this.ballX - this.snippets,10);
  		this.ctx2.closePath();*/ 
  	},
  	handleMouseDown(event){
  		this.dragStart(event);
  		window.addEventListener('mousedown', this.dragging);
  		window.addEventListener('mousemove', this.dragging);
        window.addEventListener('mouseup', this.dragEnd);
        window.addEventListener('contextmenu', this.dragEnd);
  	},
  	dragStart(event){
  		
  	    const offset = getOffSetLeft(this.canvas2);//canvas 距离浏览器左边的距离
  		this.isDragging = true;
  		this.firstX = offset;
  		const that = this;
  		this.draw(that.firstX)
  		this.$store.dispatch('moveFlag')
  	},
  	dragging(event){
		this.$store.dispatch('setDragging',true)
  		if(this.isDragging){
  			this.ballX = event.pageX - this.firstX;
  			this.$store.dispatch('getXval',this.ballX)
  			const that = this;
  			this.draw(that.ballX)
  		}
  	},
  	dragEnd(){
  		if(this.isDragging){
  			this.$store.dispatch('setDragging',false)
  			
				/*
		        * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
		        * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
		        */
		    const that = this;
		    setTimeout(function(){
		       	that.isDragging = false;
		       	that.$store.dispatch('getXval',that.ballX)
		       	const that0 = that;
		       	that.draw(that0.ballX)
		    },0)
		    window.removeEventListener('mousedown', this.dragging);
		    window.removeEventListener('mousemove', this.dragging);
          	window.removeEventListener('mouseup', this.dragEnd);
          	window.removeEventListener('contextmenu', this.dragEnd);
		}
  	}
  }

}

function linear (initPos, targetPos, currentCount, count) {
            var b = initPos,
                c = targetPos - initPos,
                t = currentCount,
                d = count;
            return c * t / d + b;
        }
//二分查找
function binarySearch(array, value) {
       let startIndex = 0,
            stopIndex = array.length - 1,
            middle = (stopIndex + startIndex) >>> 1;                      	
        //    let targetT = array[middle][2];
        	let targetT = array[middle].gpsTime;
	        let targetTi = parseFloat(timeToSec(targetT) / 3600).toFixed(2) 
            let targetTime = Number(targetTi);
        while (targetTime != value && startIndex < stopIndex) {
            if (value < targetTime) {
            	stopIndex = middle - 1;
   
            } else if (value > targetTime) {
                startIndex = middle + 1;

            }
            middle = (stopIndex + startIndex) >>> 1;
            targetT = array[middle].gpsTime;
	        targetTi = parseFloat(timeToSec(targetT) / 3600).toFixed(2) 
            targetTime = Number(targetTi);
        }
        return (targetTime != value) ? middle : middle;
    }

function getOffSetLeft(obj){
	let tmp = obj.offsetLeft;
	let val = obj.offsetParent;
	while(val != null){
		tmp += val.offsetLeft;
		val = val.offsetParent;
	}
	return tmp;
	
}


function timeToSec(num){
		let str = num + ''
		//let sec = 0;
		let h = parseInt(str.substring(6,8));
		let m = parseInt(str.substring(8,10));
		let s = parseInt(str.substring(10));
		//let totalSec = 0;
		return h * 3600 + m * 60 + s;
}
</script>

<style scoped lang="scss">
.container{
	width:80%;
	height:100px;
	padding-top:10px;
	position:absolute;
	bottom:8px;
	right:30px;
	canvas{
		position:absolute;
		right:0;
	}
	#canvas1{
		z-index:10;
	}
	#canvas3{
		z-index:11;
	}
	#canvas2{
		z-index:12;
	}
	
}
.opac {
	opacity: 0.7;
}
</style>


// WEBPACK FOOTER //
// VehicleAxis.vue?21f14824